import Index from "./routes/Index";
import ViewBox from "@bit/arey.instore-utils-react.viewbox";

function App() {
  return (
    <div className="App">
      <ViewBox height={1080} width={1920}>
        <Index />
      </ViewBox>
    </div>
  );
}

export default App;
